import React from 'react'
import { router, usePage, Link } from '@inertiajs/react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Chip, IconButton, Tooltip,
} from '@mui/material'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteIcon from '@mui/icons-material/Delete'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Index.layout = (page) => <AppShell>{page}</AppShell>

const ROLE_LABELS = {
  admin: 'Administrator',
  manager: 'Manager',
  accountant: 'Buchhalter',
  readonly: 'Nur Lesen',
}

const STATUS_CONFIG = {
  pending:  { label: 'Offen',          color: 'info' },
  accepted: { label: 'Angenommen',     color: 'success' },
  expired:  { label: 'Abgelaufen',     color: 'default' },
}

function formatDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export default function Index({ invitations = [] }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/settings`

  const handleResend = (id) => {
    router.post(`${basePath}/invitations/${id}/resend`, {}, { preserveScroll: true })
  }

  const handleRevoke = (id) => {
    router.delete(`${basePath}/invitations/${id}`, { preserveScroll: true })
  }

  return (
    <Box>
      <PageHeader
        title="Einladungen"
        breadcrumbs={[
          { label: 'Dashboard', href: `/m/${tenant.slug}` },
          { label: 'Einstellungen' },
          { label: 'Einladungen' },
        ]}
        actions={
          <Button
            component={Link}
            href={`${basePath}/invitations/new`}
            variant="contained"
            startIcon={<PersonAddIcon />}
            data-testid="new-invitation-btn"
          >
            Neue Einladung
          </Button>
        }
      />

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
              <TableCell>E-Mail</TableCell>
              <TableCell>Rolle</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Eingeladen von</TableCell>
              <TableCell>Läuft ab</TableCell>
              <TableCell align="right">Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invitations.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">Keine Einladungen.</TableCell>
              </TableRow>
            ) : (
              invitations.map((inv) => {
                const cfg = STATUS_CONFIG[inv.status] || { label: inv.status, color: 'default' }
                return (
                  <TableRow key={inv.id} data-testid={`invitation-row-${inv.id}`}>
                    <TableCell>{inv.email}</TableCell>
                    <TableCell>{ROLE_LABELS[inv.role] || inv.role}</TableCell>
                    <TableCell>
                      <Chip label={cfg.label} size="small" color={cfg.color} />
                    </TableCell>
                    <TableCell>{inv.invited_by?.display_name || inv.invited_by?.email || '—'}</TableCell>
                    <TableCell>{formatDate(inv.expires_at)}</TableCell>
                    <TableCell align="right">
                      {inv.status === 'pending' && (
                        <Tooltip title="Erneut senden">
                          <IconButton
                            size="small"
                            onClick={() => handleResend(inv.id)}
                            data-testid={`resend-btn-${inv.id}`}
                          >
                            <RefreshIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {inv.status !== 'accepted' && (
                        <Tooltip title="Widerrufen">
                          <IconButton
                            size="small"
                            onClick={() => handleRevoke(inv.id)}
                            data-testid={`revoke-btn-${inv.id}`}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                )
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
